import localeUtils from 'utils/LanguageLocale';

const getText = localeUtils.getLocaleResourceFile('constants/locales', 'Basket');

// fulfillmenttype
const BasketType = {
    Standard: null,
    SameDay: 'sameday',
    BOPIS: 'ROPIS'
};

export default {
    MESSAGES: {
        BASKET_LEVEL: {
            FREE_SHIPPING: getText('freeShipping')
        }
    },
    DELIVERY_OPTIONS: {
        STANDARD: 'Standard',
        ROUGE_FREE_SHIPPING: 'Rouge Free Shipping',
        SAME_DAY: 'Sameday',
        PICKUP: 'Pickup',
        AUTO_REPLENISH: 'Auto-Replenish'
    },
    BASKET_SWITCH: {
        ACTIONS: {
            SWITCH: 'switch',
            UNDO: 'undo'
        },
        PICKUP: 'pickup',
        SHIP_TO_HOME: 'shipToHome',
        SAME_DAY: 'sameDay'
    },
    CONTEXT: { RW_REMAINING_BALANCE: 'basket.rwRemainingBalance' },
    // The minimum points at which a reward is valuable enough to be shipping without a product
    // also being in the order
    STANDALONE_REWARD_MIN_VAL: 750,
    // Warning messages (key/messageContext) we don't want to show in the Inline Basket and show them
    // in a different way in Basket page list item

    WARNING_BLACKLIST_MESSAGES: [],
    SHOPPING_LIST_PROMO_WARNING: 'shoppingList.promoWarning',
    PROMO_WARNING: 'basket.promoWarning',
    RESTRICTED_ITEMS_REMOVED: 'basket.restrictedItemsRemoved',
    GET_IT_SHIPPED_WARNING: 'basket.shiptoHome.genericErrorMessage',
    PICK_UP_IN_STORE_WARNING: 'basket.pickupItems.genericErrorMessage',
    PICK_UP_IN_STORE_ON_HOLD: 'basket.pickupStoreReservationOnHold',
    PICK_UP_ITEMS_OUT_OF_STOCK: 'basket.pickupItemsOutOfStock',
    PICK_UP_ITEMS_OUT_OF_STOCK_SKU: 'basket.pickupsku.outOfStock',
    SDU_GIFT_CARD_UNAVAILABLE: 'basket.sduGiftCardUnavailable',
    AMOUNT_TO_FREE_SHIPPING: 'basket.amountToFreeShipping',
    FREE_SHIPPING_THRESHOLD: 'basket.thresholdFreeShipping',
    FREE_SHIPPING_ROUGE: 'basket.rougeFreeShipping',
    FREE_SHIPPING_ROUGE_CA: 'basket.rougeCAFreeShipping',
    FREE_SHIPPING_ROUGE_HAZMAT: 'basket.rougeHazmatFreeShipping',
    CBR_PROMO_MESSAGE: 'basket.promoMessages.cbr',
    PFD_PROMO_MESSAGE: 'basket.promoMessages.pfd',
    BasketType,
    ERROR_CODES: {
        ERROR_CODE_1093: -1093,
        ERROR_CODE_1081: -1081
    },
    ERROR_KEYS: {
        LIMIT_EXCEEDED: 'basket.lineItem.purchaseLimit.exceeded',
        OUT_OF_STOCK: 'basket.sku.outOfStock'
    },
    GIFT_MESSAGE_STATUS: {
        NOT_AVAILABLE: 0,
        AVAILABLE: 1,
        ADDED: 2
    },
    LANGUAGE_OPTIONS: {
        US_ENGLISH: 'giftMessages_en-US',
        SPANISH: 'giftMessages_es-US',
        CANADA_ENGLISH: 'giftMessages_en-CA',
        FRENCH: 'giftMessages_fr-CA'
    },
    ALL_TITLE: {
        ENGLISH: 'All',
        FRENCH: 'Tout'
    }
};
